import * as _ from "lodash";
import QuickJobsApi, { IPaginationParams } from ".";

interface ICollectionParams extends IPaginationParams {
  roles?: Array<"candidate" | "employer" | "root">;
  search?: string;
}

class Users {
  protected client: QuickJobsApi;

  constructor(client: QuickJobsApi) {
    this.client = client;
  }

  public getAllUsers(params?: ICollectionParams) {
    return this.client.httpClient.get("/users", {
      params: params
        ? {
            roles: params.roles ? params.roles.join(",") : undefined,
            search: params.search,
            ..._.pick(params, ["until", "since", "limit", "orderBy"])
          }
        : null
    });
  }

  public getUser(id: number) {
    return this.client.httpClient.get(`/users/${id}`);
  }

  public block(id: number, block: boolean) {
    return this.client.httpClient.post(`/users/${id}/block`);
  }

  public remove(id: number) {
    return this.client.httpClient.delete(`/users/${id}`);
  }

  public getReviews(userId: number, params?: IPaginationParams) {
    return this.client.httpClient.get(`/users/${userId}/reviews`, {
      params: params
    });
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/libs/quickjobs-api/users.ts